// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"893":"42ced442","976":"48307b3b"}[chunkId] + ".chunk.js";
};